import { StyleHelper } from "../../style/style.js";
import { Helper } from "./helper.js";
import React from "react";
export class DefaultProfilePictureGenerator {
    private static colors = [
        {
            dark: "#b71c1c",
            bright: "#ffebee"
        },
        {
            dark: "#880e4f",
            bright: "#fce4ec"
        },
        {
            dark: "#4a148c",
            bright: "#f3e5f5"
        },
        {
            dark: "#311b92",
            bright: "#ede7f6"
        },
        {
            dark: "#1a237e",
            bright: "#e8eaf6"
        },
        {
            dark: "#0d47a1",
            bright: "#e3f2fd"
        },
        {
            dark: "#01579b",
            bright: "#e1f5fe"
        },
        {
            dark: "#006064",
            bright: "#e0f7fa"
        },
        {
            dark: "#004d40",
            bright: "#e0f2f1"
        },
        {
            dark: "#1b5e20",
            bright: "#e8f5e9"
        },
        {
            dark: "#33691e",
            bright: "#f1f8e9"
        },
        {
            dark: "#827717",
            bright: "#f9fbe7"
        },
        {
            dark: "#f57f17",
            bright: "#fffde7"
        },
        {
            dark: "#ff6f00",
            bright: "#fff8e1"
        },
        {
            dark: "#e65100",
            bright: "#fff3e0"
        },
        {
            dark: "#bf360c",
            bright: "#fbe9e7"
        },
        {
            dark: "#6d4c41",
            bright: "#efebe9"
        },
        {
            dark: "#616161",
            bright: "#fafafa"
        },
        {
            dark: "#455a64",
            bright: "#eceff1"
        }
    ];

    static generateNode = (name: string, size: number) => {
        const { color, initals } = this.getData(name);
        const wrapper = document.createElement("div");
        wrapper.style.height = `${size}px`;
        wrapper.style.width = `${size}px`;
        wrapper.style.display = "flex";
        wrapper.style.justifyContent = "center";
        wrapper.style.alignItems = "center";
        wrapper.style.backgroundColor = color.bright;
        wrapper.style.borderRadius = "50%";
        wrapper.style.border = `1px solid ${color.dark}`
        wrapper.style.cursor = "pointer";

        const label = document.createElement("label");
        label.style.color = color.dark;
        label.style.fontSize = `${size * 0.45 * (2 / initals.length)}px`;
        label.innerHTML = initals;
        label.style.cursor = "pointer";

        wrapper.appendChild(label);

        return wrapper;
    }

    static generateJSX = (options: GeneratorOptions) => {
        const { color, initals } = this.getData(options.name);
        const background = options.background == "bright" ? color.bright : color.dark;
        const font = options.background == "bright" ? color.dark : StyleHelper.getFontColor(color.dark);
        return (
            <div style={{ height: `${options.size}px`, width: `${options.size}px`, display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: background, borderRadius: options.form == "circle" ? "50%" : "25%" }}>
                <label style={{ color: font, fontSize: `${options.size * 0.45 * (2 / initals.length)}px` }} >{initals}</label>
            </div>
        );
    }

    static generateString = (options: GeneratorOptions) => {
        const { color, initals } = this.getData(options.name);
        const background = options.background == "bright" ? color.bright : color.dark;
        const font = options.background == "bright" ? color.dark : StyleHelper.getFontColor(color.dark);
        return `<div style="height: ${options.size}px; width: ${options.size}px; display: flex; justify-content: center; align-items: center; background-color: ${background}; border-radius: ${options.form == "circle" ? "50" : "25"}%;">
	                <label style="color: ${font}; font-size: ${options.size * 0.45 * (2 / initals.length)}px;">
		                ${initals}
	                </label>
                </div>`;
    }

    private static getData = (name: string) => {
        if (Helper.isNullOrEmpty(name)) {
            return { color: { bright: "#fafafa", dark: "#212121" }, initals: "UU" }
        }
        name = name.trim().toUpperCase();
        const hash = Helper.getHashCode(name);
        const index = hash % this.colors.length;
        const color = this.colors[Math.abs(index)];

        let initals = name.split(' ').map((value) => {
            if (value.length > 0) {
                return value[0];
            }
            return ''
        }).join('');
        initals = initals.length > 3 ? initals.substring(0, 3) : initals;
        return { color, initals };
    }


}

interface GeneratorOptions {
    name: string;
    size: number;
    background: "bright" | "dark";
    form: "circle" | "square"
}